<template>
  <div>
    <h2>FormHealthStatusMonitoring</h2>
  </div>
</template>

<script>
  export default {
    name: "FormHealthStatusMonitoring",
  }
</script>

<style lang="css" scoped>

</style>